import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Globe } from 'lucide-react';
import { Card } from '@/components/ui/card';

interface InternetNodeData {
  id: string;
  label: string;
  supplier?: string;
  connectionType?: string;
}

interface InternetNodeProps {
  data: InternetNodeData;
  selected: boolean;
}

export const InternetNode = memo(({ data, selected }: InternetNodeProps) => {
  return (
    <>
      <Card className={`min-w-[180px] ${selected ? 'ring-2 ring-primary shadow-lg' : ''}`}>
        <div className="p-3 bg-gradient-to-br from-blue-50 to-cyan-50 dark:from-blue-950 dark:to-cyan-950">
          <div className="flex items-center gap-2">
            <Globe className="h-5 w-5 text-blue-600 dark:text-blue-400" />
            <div className="flex-1">
              <div className="font-semibold text-sm">{data.label}</div>
              {data.connectionType && (
                <div className="text-xs text-muted-foreground">{data.connectionType}</div>
              )}
              {data.supplier && (
                <div className="text-xs text-muted-foreground">via {data.supplier}</div>
              )}
            </div>
          </div>
        </div>
      </Card>

      {/* 4 bidirectional handles - isConnectableStart + isConnectableEnd allow both directions */}
      <Handle id="top" type="source" position={Position.Top} isConnectableStart={true} isConnectableEnd={true} className="w-3 h-3 border-2 border-blue-600 bg-blue-200 dark:bg-blue-800" />
      <Handle id="left" type="source" position={Position.Left} isConnectableStart={true} isConnectableEnd={true} className="w-3 h-3 border-2 border-blue-600 bg-blue-200 dark:bg-blue-800" />
      <Handle id="right" type="source" position={Position.Right} isConnectableStart={true} isConnectableEnd={true} className="w-3 h-3 border-2 border-blue-600 bg-blue-200 dark:bg-blue-800" />
      <Handle id="bottom" type="source" position={Position.Bottom} isConnectableStart={true} isConnectableEnd={true} className="w-3 h-3 border-2 border-blue-600 bg-blue-200 dark:bg-blue-800" />
    </>
  );
});

InternetNode.displayName = 'InternetNode';
